import React from 'react';

import banner from '../images/banner_new.png';
import handy from '../images/handy.jpg';
import '../App.css';
import ContactForm from './Contactform.js';
import screenshot from '../images/screenshot problems.png'
import world from '../images/World_changed.jpg'
import why_pic from '../images/why_do_this.jpg'
import our_mission_pic from '../images/our_mission.png'

function Content() {
  return (
    <div className="maincontent">
  
 
  <div className="container-fluid p-0 position-relative">
      <img src={banner} className="img-fluid custom-height" alt="logo" />
      <div className="position-absolute bottom-0 p-3">
        <h1 className="text-white">Donate ...</h1>
        <h3 className="text-white">... and change the world</h3>
      </div>
    </div>
      <div>
        <div className="container">
        <div class="column picture">
            <img src={our_mission_pic}  style={{ height: "70%" }} alt="picture"></img>
          </div>
          <div class="column blank"></div>
          <div class="column text text-end">
            <h1> Our </h1>
            <h1> misson...</h1>
            <div style={{ padding: "70px" }}> </div>
            <p>…is to revolutionize donations, using technology and empathy to transform the world into a brighter, more compassionate place where every contribution reshapes what's possible.</p>
          </div>
          <div class="column blank-right"></div>
        </div>

        <div className="container">
        <div class="column text text-start">
            <h1> The world changed </h1>
            <h1> donating did not...</h1>
            <div style={{ padding: "70px" }}> </div>
            <p>… donating can still be a complicated and difficult process so there is a need to simplify it. The willingness to donate is in directly relatable to the problems faced when trying to donate to charity</p>
          </div>
          <div class="column blank"></div>
          
          <div class="column picture">
            <img src={world} alt="picture"></img>
          </div>
          <div class="column blank-right"></div>
        </div>
      </div>
      

      <div className="container">
        <div class="column picture">
            <img src={why_pic} alt="picture"></img>
          </div>
          <div class="column blank"></div>
          <div class="column text text-end">
            <h1> Why do</h1>
            <h1> we do this...</h1>
            <div style={{ padding: "70px" }}> </div>
            <p>… Because we believe in reimagining the world of giving, making it accessible, impactful, and trustworthy for all to create a brighter and more compassionate future. We must act now to create good for humanity with innovative and technologically adapted methods. 
</p>
          </div>
          <div class="column blank-right"></div>
        </div>
      




      <div style={{ padding: "90px" }}>
      </div>
     
      
    </div>
  );
}

function Home() {
  return (
    <div className="App">
      

      <Content />

      
    </div>
  );
}

export default Home;
